import React from "react";
import autoBind from "react-autobind";
import FieldArea from "../../../components/FieldArea";
import FieldCheck from "../../../components/FieldCheck";
import {Panel} from "../../../components/Panel";
import feathers from "../../../feathers";
import noty from "../../../lib/noty";

export default class Feedback extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      touched: false,
      data: {
        feedback: "",
        contactBack: false
      },
      fetching: false
    };
  }

  handleSubmit = event => {
    event.preventDefault();
    const {feedback, contactBack} = this.state.data;
    this.setState({fetching: true});
    feathers
      .service("api/feedback")
      .create({feedback, contactBack})
      .then(({message}) => {
        this.setState({
          touched: false,
          fetching: false,
          data: {
            feedback: "",
            contactBack: false
          }
        });
        noty.success(message);
      })
      .catch(err => {
        this.setState({fetching: false});
        noty.errors(err);
      });
  };

  handleChange = ({name, value}) => {
    this.setState({
      touched: true,
      data: {...this.state.data, [name]: value}
    });
  };

  render() {
    const {touched, fetching} = this.state;
    const {contactBack, feedback} = this.state.data;
    return (
      <Panel
        onSaveClick={this.handleSubmit}
        saveTitle="Send Feedback"
        fetching={fetching}
        touched={touched}
        touchedMessage="Are you sure you want to leave? Your feedback has not been sent.">
        <div>
          <div className="row">
            <div className="col-xs-12">
              <h3>We want to hear your ideas and complaints!</h3>
              <br />
              <p>
                How could we make MapPlug better for you? Have you found any bugs or issues? Your feedback is highly
                valuable. Please let us know so that we can make MapPlug better for you and everyone.
              </p>
            </div>
          </div>
          <div className="row">
            <div id="form-feedback" className="col-xs-12">
              <FieldArea
                label="What's your feedback?"
                name="feedback"
                rows={20}
                value={feedback}
                onChange={this.handleChange}
                disabled={fetching}
              />
            </div>
            <div id="form-feedback" className="col-xs-12">
              <FieldCheck
                label="I would like to be contacted about this feedback."
                name="contactBack"
                value={contactBack}
                checked={contactBack}
                onChange={({name, value}) => {
                  this.handleChange({name, value: !value});
                }}
                disabled={fetching}
              />
            </div>
          </div>
        </div>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Account/Feedback/index.jsx